import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { AccountMenuPopover } from '../../components/account/account-menu/AccountMenuPopover';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useOAuth } from '../../hooks/useOAuth';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
export const AccountMenuContainer = ({ items, anchorEl, onClose }) => {
    const dispatch = useDispatch();
    const { logout } = useOAuth();
    const isNewAuthFlowEnabled = useFeatureToggle('use_new_auth_flow');
    const handleLogout = () => {
        isNewAuthFlowEnabled ? logout() : dispatch(sessionActions.createLogoutAction());
    };
    return _jsx(AccountMenuPopover, { items: items, anchorEl: anchorEl, onClose: onClose, logout: handleLogout });
};
